import s from '../solution-rate-reviews.scss';
import { composer } from '../../../../../component-decorators/composer';
import React from 'react';
import { SolutionReview } from './solution-review';
import { ReviewsSectionHeader } from './reviews-section-header';
import { Box, Card, TextButton, Divider, Layout, Cell, } from 'wix-style-react';
import { HelpfulReview } from "./helpful-review";
import { useConfigContext } from "../../../../../config-context";
export var dtoToSolutionReviews = function (solutionDto) {
    return solutionDto.body.reviews;
};
export var SolutionReviews = composer()
    .withExperiments()
    .withTranslation()
    .compose(function (props) {
    // tslint:disable-next-line:react-hooks-nesting
    var isMobile = useConfigContext().isMobile;
    return (React.createElement(Card, { className: s.solutionReviewsContainer },
        React.createElement("span", { vocab: "https://schema.org/", typeof: "Review" },
            React.createElement(Card.Content, null,
                React.createElement(ReviewsSectionHeader, { editMode: props.editMode, showDeletedLink: props.showDeletedLink, afterPostRender: props.afterPostRender, sortBy: props.sortBy, reviews: props.numberOfReviews, isEligibleForReviews: props.isEligibleForReviews, appId: props.appId }),
                isMobile &&
                    React.createElement(Box, { marginTop: "15px", marginBottom: "16px" },
                        React.createElement(Divider, null)),
                props.reviews &&
                    props.reviews.map(function (review, index, array) {
                        return (React.createElement("div", { key: review.id },
                            React.createElement(Layout, null,
                                React.createElement(Cell, { span: 12 },
                                    React.createElement(SolutionReview, { ratingCount: props.numberOfReviews, averageRating: props.averageRating, appName: props.appName, developerName: props.developerName, developerIcon: props.developerIcon, review: review, key: review.id, appId: props.appId, index: index }),
                                    React.createElement(HelpfulReview, { appId: props.appId, review: review }))),
                            props.hideLoadMoreBtn &&
                                index === array.length - 1 ? null : (React.createElement("div", { className: s.reviewDivider },
                                React.createElement(Divider, null)))));
                    }),
                React.createElement(Box, { align: "center" }, props.hideLoadMoreBtn ? null : (React.createElement(TextButton, { dataHook: "load-more", onClick: props.loadMore }, props.t('solution.page.reviewsViewMore'))))))));
});
//# sourceMappingURL=solution-reviews.js.map